import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { logout } from "src/store/authSlice";
import { Page } from "src/interfaces/Page";
import { RootState } from "../../store";
import { coursesSelector } from "../coursesSlice";
import { getXapiAndScromCourses } from "src/actions/courseActions/learnerCourseActions";

const ScromXapiCoursesPaginationAdapter = createEntityAdapter<Page>();

const initialState = {
  pages: ScromXapiCoursesPaginationAdapter.getInitialState(),
  total: 0,
  totalItems: 0,
};

export const ScromXapiCoursesPaginationSlice = createSlice({
  name: "scromXapi/pagination",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //FIXME:
    builder.addCase(getXapiAndScromCourses.fulfilled, (state, { payload }) => {
      return {
        pages: ScromXapiCoursesPaginationAdapter.upsertOne(
          { ...state.pages },
          {
            id: parseInt(payload.currentPage),
            items: payload?.data?.map((item: any) => item.courses.id),
          }
        ),
        total: payload.pages,
        totalItems: payload.items,
      };
    });
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const adapterSelectors = ScromXapiCoursesPaginationAdapter.getSelectors(
  (s: RootState) => s.ScromXapiCoursesPagination.pages
);

export const scromAndXapiPaginationSelectors = {
  pages: adapterSelectors,
  get: (state: RootState, page: number) =>
    adapterSelectors
      .selectById(state, page)
      ?.items.map((id: number) =>
        coursesSelector.coursesSelector.selectById(state, id)
      ) || [],
  totalPages: (state: RootState) => state.ScromXapiCoursesPagination.total,

  // total: (state: RootState) => state.continueLearning.totalItems,
};
